import { TransferPricingDocumentationRequestHelper } from './transfer-pricing-documentation-request-helper';
import type {
  ICreateTransferPricingDocumentationVersionParams,
  ICreateTransferPricingDocumentationVersionResponse,
  TTransferPricingDocumentationMutationResult,
} from './types';

const FALLBACK_ERROR_MESSAGE = 'Could not save the version. Please try again.';

export const createTransferPricingDocumentationVersion = (
  documentationId: string,
  params: ICreateTransferPricingDocumentationVersionParams,
  token?: string
): Promise<
  TTransferPricingDocumentationMutationResult<ICreateTransferPricingDocumentationVersionResponse>
> =>
  TransferPricingDocumentationRequestHelper.send({
    path: `${TransferPricingDocumentationRequestHelper.recordPath(documentationId)}/version`,
    method: 'POST',
    body: { ...params },
    isExpectedBody:
      TransferPricingDocumentationRequestHelper.isCreateVersionResponse,
    fallbackErrorMessage: FALLBACK_ERROR_MESSAGE,
    token,
  });
